import { createFileRoute } from "@tanstack/react-router";
import { alternateLinkList } from "@/lib/i18n/locale";
import { LegalPage, P, UL } from "@/components/marketing/LegalPage";

export const Route = createFileRoute("/vi/legal/anti-spam")({
  head: () => ({
    meta: [
      { title: "Chính sách Chống thư rác — Banana Cards" },
      { name: "description", content: "Quy tắc gửi email, sự đồng ý, nội dung bị cấm và biện pháp xử lý đối với tin nhắn gửi qua Banana Cards." },
      { property: "og:title", content: "Chính sách Chống thư rác — Banana Cards" },
      { property: "og:description", content: "Quy tắc gửi email và nội dung bị cấm trên Banana Cards." },
    ],
    links: alternateLinkList("/legal/anti-spam", "vi"),
  }),
  component: AntiSpamPageVi,
});

function AntiSpamPageVi() {
  return (
    <LegalPage
      eyebrow="Pháp lý · Tin cậy"
      title="Chính sách"
      italic="Chống thư rác."
      updated="Tháng 1, 2026"
      intro="Banana Cards cung cấp cho bạn công cụ để gửi email đến danh bạ của mình — email chào mừng, email theo dõi, chiến dịch, chữ ký, và tự động hóa. Chính sách này giải thích các quy tắc mà mọi người gửi phải tuân thủ, nội dung nào bị cấm, và cách chúng tôi thực thi các quy tắc này để bảo vệ khả năng gửi thư cho toàn bộ nền tảng."
      related={[
        { label: "Điều khoản dịch vụ", to: "/vi/terms" },
        { label: "Chính sách bảo mật", to: "/vi/privacy" },
        { label: "Hướng dẫn sử dụng hợp pháp & đạo đức", to: "/vi/legal-guidelines" },
      ]}
      sections={[
        {
          id: "scope",
          title: "1. Phạm vi áp dụng",
          body: (
            <P>
              Chính sách này áp dụng cho mọi email, tin nhắn hoặc thông báo được gửi qua Banana Cards — bao gồm email chào mừng, chuỗi email theo dõi, chiến dịch quảng bá, tin nhắn giao dịch, chữ ký email, thông báo hợp đồng, xác nhận lịch hẹn, yêu cầu đánh giá, và bất kỳ tự động hóa nào dẫn đến việc gửi tin nhắn đến người nhận thay mặt bạn.
            </P>
          ),
        },
        {
          id: "consent",
          title: "2. Sự đồng ý và cho phép",
          body: (
            <>
              <P>Bạn chỉ được gửi tin nhắn cho người nhận đã cho phép bạn liên hệ. Các cơ sở gửi tin được chấp nhận bao gồm:</P>
              <UL items={[
                "người nhận đã tự nguyện đăng ký (biểu mẫu, ô đánh dấu, xác nhận kép)",
                "người nhận đã đưa danh thiếp cho bạn tại sự kiện, cuộc họp hoặc triển lãm",
                "người nhận là khách hàng hiện tại hoặc đối tác kinh doanh đang hoạt động dựa trên lợi ích chính đáng theo luật địa phương",
                "người nhận đã yêu cầu thông tin, báo giá, lịch hẹn, hợp đồng hoặc phản hồi",
              ]} />
              <P>Danh sách email được mua, thuê, thu thập tự động hoặc lấy được bằng cách khác đều bị nghiêm cấm. Việc tải lên danh sách mà bạn không tự thu thập là vi phạm nghiêm trọng chính sách này.</P>
            </>
          ),
        },
        {
          id: "email-conduct",
          title: "3. Quy tắc gửi email",
          body: (
            <>
              <P>Khi gửi qua Banana Cards, bạn phải:</P>
              <UL items={[
                "sử dụng tên người gửi và địa chỉ trả lời chính xác — không mạo danh hoặc giả mạo",
                "sử dụng tiêu đề phản ánh đúng nội dung tin nhắn — không lừa đảo, gây hiểu lầm hoặc câu view",
                "xác định rõ bản thân hoặc doanh nghiệp trong nội dung tin nhắn",
                "cung cấp địa chỉ vật lý hợp lệ khi pháp luật yêu cầu (ví dụ CAN-SPAM, PECR, CASL)",
                "cung cấp cơ chế hủy đăng ký một-nhấp-chuột hoạt động trong mọi email tiếp thị",
                "tôn trọng yêu cầu hủy đăng ký ngay lập tức và không bao giờ thêm lại một liên hệ đã hủy",
                "tôn trọng múi giờ, giờ nghỉ và kỳ vọng văn hóa của người nhận",
                "duy trì tần suất gửi hợp lý và phù hợp với kỳ vọng của người nhận",
              ]} />
            </>
          ),
        },
        {
          id: "prohibited-content",
          title: "4. Nội dung bị cấm",
          body: (
            <>
              <P>Bạn không được sử dụng Banana Cards để gửi tin nhắn chứa hoặc quảng bá:</P>
              <UL items={[
                "thư rác không được yêu cầu (spam) dưới mọi hình thức",
                "lừa đảo, gian lận, phishing, giả mạo, hoặc kỹ thuật xã hội",
                "phần mềm độc hại, virus, ransomware, phần mềm gián điệp, liên kết hoặc tệp đính kèm độc hại",
                "nội dung người lớn, khiêu dâm, dịch vụ tình dục",
                "ma túy bất hợp pháp, chất bị kiểm soát, hoặc dược phẩm không được cấp phép",
                "cờ bạc bất hợp pháp, cá cược không được cấp phép, hoặc xổ số gian lận",
                "phát ngôn thù ghét, quấy rối, đe dọa, kích động bạo lực hoặc phân biệt đối xử",
                "bán vũ khí, chất nổ hoặc các mặt hàng bị hạn chế nơi bị cấm",
                "mô hình đa cấp, chiêu trò làm giàu nhanh, hoặc kế hoạch đầu tư gian lận",
                "thao túng tiền điện tử, chứng khoán không đăng ký, hoặc tư vấn tài chính trái phép",
                "hàng giả, phần mềm crack, nội dung vi phạm bản quyền",
                "nội dung vi phạm quyền riêng tư của người khác hoặc phơi bày dữ liệu cá nhân",
                "bất kỳ nội dung nào vi phạm Điều khoản dịch vụ hoặc Hướng dẫn sử dụng của chúng tôi",
              ]} />
            </>
          ),
        },
        {
          id: "technical",
          title: "5. Yêu cầu kỹ thuật",
          body: (
            <>
              <P>Để bảo vệ khả năng gửi thư cho mọi người dùng, bạn phải:</P>
              <UL items={[
                "xác thực tên miền gửi bằng SPF, DKIM và DMARC khi sử dụng tên miền tùy chỉnh",
                "giữ tỷ lệ trả lại dưới 5% và tỷ lệ khiếu nại thư rác dưới 0,1%",
                "xóa ngay các địa chỉ trả lại vĩnh viễn khỏi danh sách",
                "không cố gắng vượt qua, vô hiệu hóa, ẩn hoặc xóa liên kết hủy đăng ký",
                "không cố gắng vượt qua giới hạn tốc độ, điều tiết hoặc kiểm soát chống lạm dụng",
                "không gửi từ tên miền tạm thời, dùng một lần hoặc mới đăng ký nhằm né tránh bộ lọc",
              ]} />
            </>
          ),
        },
        {
          id: "automations",
          title: "6. Tự động hóa và chuỗi email",
          body: (
            <P>
              Các chuỗi tự động (chiến dịch nhỏ giọt, luồng theo dõi, yêu cầu đánh giá, chuỗi chào mừng) phải tuân thủ cùng quy tắc về sự đồng ý, ứng xử và nội dung như tin nhắn gửi thủ công. Bạn chịu trách nhiệm về tin nhắn mà tự động hóa của bạn gửi thay mặt bạn — bao gồm tự động hóa được cấu hình trong AI Brain, CRM, Bookings, Contracts hoặc Reviews.
            </P>
          ),
        },
        {
          id: "reporting",
          title: "7. Báo cáo lạm dụng",
          body: (
            <P>
              Nếu bạn nhận được tin nhắn gửi qua Banana Cards mà bạn cho rằng vi phạm chính sách này, vui lòng báo cáo tới <a href="mailto:abuse@banana.cards" className="font-bold underline-offset-4 hover:underline">abuse@banana.cards</a>. Vui lòng đính kèm toàn bộ tin nhắn kèm header nếu có thể. Chúng tôi điều tra mọi báo cáo.
            </P>
          ),
        },
        {
          id: "enforcement",
          title: "8. Thực thi",
          body: (
            <>
              <P>Khi chúng tôi có cơ sở hợp lý để tin rằng chính sách này đã bị vi phạm, chúng tôi có thể, mà không cần thông báo trước:</P>
              <UL items={[
                "điều tiết, trì hoãn, cách ly hoặc từ chối gửi tin nhắn",
                "vô hiệu hóa từng chiến dịch, tự động hóa hoặc danh tính người gửi",
                "tạm ngưng hoặc chấm dứt tài khoản chịu trách nhiệm",
                "gỡ bỏ hoặc vô hiệu hóa tên miền tùy chỉnh và bản ghi xác thực",
                "giữ lại việc xuất dữ liệu hoặc hạn chế truy cập trong khi điều tra",
                "báo cáo tài khoản tới danh sách chặn, nhà cung cấp hộp thư, nhà cung cấp thanh toán hoặc cơ quan có thẩm quyền theo luật định",
              ]} />
              <P>Các quyết định thực thi được đưa ra với thiện chí nhằm bảo vệ người nhận, khả năng gửi thư và tính toàn vẹn của nền tảng. Vi phạm lặp lại hoặc nghiêm trọng sẽ dẫn đến chấm dứt vĩnh viễn mà không hoàn tiền.</P>
            </>
          ),
        },
        {
          id: "changes",
          title: "9. Thay đổi chính sách",
          body: (
            <P>
              Chúng tôi có thể cập nhật chính sách này theo thời gian để phản ánh thay đổi của pháp luật, yêu cầu của nhà cung cấp hộp thư hoặc tính năng nền tảng. Các thay đổi quan trọng sẽ được thông báo trong sản phẩm hoặc qua email. Tiếp tục sử dụng Banana Cards sau khi cập nhật đồng nghĩa với việc chấp nhận chính sách sửa đổi.
            </P>
          ),
        },
      ]}
    />
  );
}